/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestToken__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
TestToken__factory.bytecode = _bytecode;
TestToken__factory.abi = _abi;
//# sourceMappingURL=TestToken__factory.js.map